import React, { useState, useEffect, useContext } from 'react';
import { Box, CircularProgress } from '@mui/material';
import ParamContext from '../contexts/paramContext';

const CarLogo = ({ brand, size = 30, height="", width="", variant = 'thumb', showPlaceholder = false, logosData, loading, error }) => {
	const param = useContext(ParamContext);

	// Normaliser le nom de la marque pour la recherche
	const normalizeBrand = (brandName) => {
		if (!brandName) return '';
		return brandName.toLowerCase()
			.replace(/[^\w\s-]/g, '')
			.replace(/\s+/g, '-')
			.trim();
	};

	// Chercher le logo correspondant
	const findLogo = () => {
		if (!brand || logosData?.length === 0) return null;

		const normalizedSearch = normalizeBrand(brand);

		// Chercher par slug exact
		let logo = logosData?.find(item => item.slug === normalizedSearch);

		// Si pas trouvé, chercher par nom
		if (!logo) {
			logo = logosData?.find(item =>
				item.name.toLowerCase() === brand.toLowerCase() ||
				item.name.toLowerCase().includes(brand.toLowerCase())
			);
		}

		return logo;
	};

	// Afficher un indicateur de chargement
	if (loading) {
		return (
			<Box
				sx={{
					width: size,
					height: size,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center'
				}}
			>
				<CircularProgress size={size * 0.5} />
			</Box>
		);
	}

	// Afficher une erreur
	if (error) {
		console.error('Erreur CarLogo:', error);
		return showPlaceholder ? (
			<Box
				sx={{
					width: size,
					height: size,
					borderRadius: '50%',
					bgcolor: '#ffebee',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					fontSize: size * 0.4,
					color: '#c62828',
					border: '1px solid #ef5350',
				}}
			>
				!
			</Box>
		) : null;
	}

	const logo = findLogo();

	// Si aucun logo trouvé
	if (!logo) {
		return (
			<>
				{brand || ''}
			</>
		);
	}

	// l'URL complète de l'image
	const baseUrl = `${param.urlimg}`;
	const imageUrl = logo.image[variant] || logo.image.thumb;
	const fullImageUrl = imageUrl.startsWith('http')
		? imageUrl
		: `${baseUrl}${imageUrl}`.replace(/([^:]\/)\/+/g, '$1');

	return (
		<Box
			component="img"
			src={fullImageUrl}
			alt={`Logo ${logo.name}`}
			// title={logo.name}
			sx={{
				width: width ? width : size,
				height: height? height : size,
				objectFit: 'contain',
				borderRadius: '4px',
			}}
			onError={(e) => {
				// Fallback si l'image ne charge pas
				e.target.style.display = 'none';
				e.target.parentElement.innerHTML = `<div style="width:${size}px;height:${size}px;background:#f0f0f0;display:flex;align-items:center;justify-content:center;border-radius:4px;font-size:${size * 0.4}px;color:#999;">${brand ? brand.charAt(0).toUpperCase() : '?'}</div>`;
			}}
		/>
	);
};

export default CarLogo;